// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./components/accordion/style/index.less
 ** module id = 137
 ** module chunks = 0
 **/